import { render } from "./UploadFile.vue?vue&type=template&id=516ba3bb&ts=true"
import script from "./UploadFile.vue?vue&type=script&lang=ts"
export * from "./UploadFile.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__